import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux';
import { closeAlertDialog } from 'store/features/alertSlice';

const AlertDialog = () => {
  const { open, title, contentText, size, hideOkButton } = useSelector((state) => state.alert);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeAlertDialog());
  };

  return (
    <Dialog maxWidth={size} fullWidth open={open} onClose={handleClose}>
      <DialogTitle variant="h3">{title}</DialogTitle>
      {contentText && (
        <DialogContent>
          <Typography variant="subtitle1">{contentText}</Typography>
        </DialogContent>
      )}
      {!hideOkButton && (
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>
            Ok
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default AlertDialog;
